export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5062";

export const MEDIA_BASE_URL =
  process.env.REACT_APP_MEDIA_BASE_URL || "http://localhost:5062";
